import React from 'react'

import HeadingNew from 'presentation/shared/components/HeadingNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import { ReactComponent as TextureIllustration } from 'presentation/assets/illustrations/texture-illustration.svg'
import { ReactComponent as MegaphoneIllustration } from 'presentation/assets/illustrations/megaphone-illustration.svg'

import * as S from './styles'

const SystemRecoveryBanner = () => (
  <S.Wrapper>
    <S.TextWrapper>
      <HeadingNew
        as="h3"
        color="white"
        weight="bold"
        size="small"
        style={{ lineHeight: 1.3 }}
      >
        Meu Mater Dei está de volta!
      </HeadingNew>
      <SupportTextNew
        color="success50"
        fontFamily="secondary"
        size="xsmall"
        style={{ lineHeight: 1.5 }}
      >
        Nos próximos dias poderão ocorrer instabilidades pontuais durante o
        processo de estabilização.
      </SupportTextNew>
    </S.TextWrapper>

    <S.Illustrations aria-hidden>
      <S.TextureIllustration>
        <TextureIllustration />
      </S.TextureIllustration>
      <S.MegaphoneIllustration>
        <MegaphoneIllustration />
      </S.MegaphoneIllustration>
    </S.Illustrations>
  </S.Wrapper>
)

export default SystemRecoveryBanner
